export default [
  {alpha: 'AF', name: 'Afeganistão'},
  {alpha: 'ZA', name: 'África do Sul'},
  {alpha: 'AX', name: 'Åland'},
  {alpha: 'AL', name: 'Albânia'},
  {alpha: 'DE', name: 'Alemanha'},
  {alpha: 'AD', name: 'Andorra'},
  {alpha: 'AO', name: 'Angola'},
  {alpha: 'AI', name: 'Anguila'},
  {alpha: 'AQ', name: 'Antártica'},
  {alpha: 'AG', name: 'Antígua e Barbuda'},
  {alpha: 'SA', name: 'Arábia Saudita'},
  {alpha: 'DZ', name: 'Argélia'},
  {alpha: 'AR', name: 'Argentina'},
  {alpha: 'AM', name: 'Armênia'},
  {alpha: 'AW', name: 'Aruba'},
  {alpha: 'AU', name: 'Austrália'},
  {alpha: 'AT', name: 'Áustria'},
  {alpha: 'AZ', name: 'Azerbaijão'},
  {alpha: 'BS', name: 'Bahamas'},
  {alpha: 'BH', name: 'Bahrein'},
  {alpha: 'BD', name: 'Bangladesh'},
  {alpha: 'BB', name: 'Barbados'},
  {alpha: 'BY', name: 'Belarus'},
  {alpha: 'BE', name: 'Bélgica'},
  {alpha: 'BZ', name: 'Belize'},
  {alpha: 'BJ', name: 'Benin'},
  {alpha: 'BM', name: 'Bermuda'},
  {alpha: 'BO', name: 'Bolívia'},
  {alpha: 'BQ', name: 'Bonaire, Santo Eustáquio e Saba'},
  {alpha: 'BA', name: 'Bósnia e Herzegovina'},
  {alpha: 'BW', name: 'Botsuana'},
  {alpha: 'BR', name: 'Brasil'},
  {alpha: 'BN', name: 'Brunei Darussalam'},
  {alpha: 'BG', name: 'Bulgária'},
  {alpha: 'BF', name: 'Burquina Faso'},
  {alpha: 'BI', name: 'Burundi'},
  {alpha: 'BT', name: 'Butão'},
  {alpha: 'CV', name: 'Cabo Verde'},
  {alpha: 'CM', name: 'Camarões'},
  {alpha: 'KH', name: 'Camboja'},
  {alpha: 'CA', name: 'Canadá'},
  {alpha: 'QA', name: 'Catar'},
  {alpha: 'KZ', name: 'Cazaquistão'},
  {alpha: 'TD', name: 'Chade'},
  {alpha: 'CL', name: 'Chile'},
  {alpha: 'CN', name: 'China'},
  {alpha: 'CY', name: 'Chipre'},
  {alpha: 'VA', name: 'Cidade do Vaticano'},
  {alpha: 'CO', name: 'Colômbia'},
  {alpha: 'KM', name: 'Comoros'},
  {alpha: 'CG', name: 'Congo (Brazavile)'},
  {alpha: 'CD', name: 'Congo (Quinxassa)'},
  {alpha: 'KR', name: 'Coreia do Sul'},
  {alpha: 'CR', name: 'Costa Rica'},
  {alpha: 'CI', name: "Côte d'Ivoire"},
  {alpha: 'HR', name: 'Croácia'},
  {alpha: 'CW', name: 'Curaçao'},
  {alpha: 'DK', name: 'Dinamarca'},
  {alpha: 'DJ', name: 'Djibuti'},
  {alpha: 'DM', name: 'Dominica'},
  {alpha: 'EG', name: 'Egito'},
  {alpha: 'SV', name: 'El Salvador'},
  {alpha: 'AE', name: 'Emirados Árabes Unidos'},
  {alpha: 'EC', name: 'Equador'},
  {alpha: 'ER', name: 'Eritreia'},
  {alpha: 'SK', name: 'Eslováquia'},
  {alpha: 'SI', name: 'Eslovênia'},
  {alpha: 'ES', name: 'Espanha'},
  {alpha: 'SZ', name: 'Essuatíni'},
  {alpha: 'US', name: 'Estados Unidos da América'},
  {alpha: 'EE', name: 'Estônia'},
  {alpha: 'ET', name: 'Etiópia'},
  {alpha: 'FJ', name: 'Fiji'},
  {alpha: 'PH', name: 'Filipinas'},
  {alpha: 'FI', name: 'Finlândia'},
  {alpha: 'FR', name: 'França'},
  {alpha: 'GA', name: 'Gabão'},
  {alpha: 'GM', name: 'Gâmbia'},
  {alpha: 'GH', name: 'Gana'},
  {alpha: 'GE', name: 'Geórgia'},
  {alpha: 'GI', name: 'Gibraltar'},
  {alpha: 'GD', name: 'Granada'},
  {alpha: 'GR', name: 'Grécia'},
  {alpha: 'GL', name: 'Groenlândia'},
  {alpha: 'GP', name: 'Guadalupe'},
  {alpha: 'GU', name: 'Guam'},
  {alpha: 'GT', name: 'Guatemala'},
  {alpha: 'GG', name: 'Guernsey'},
  {alpha: 'GY', name: 'Guiana'},
  {alpha: 'GF', name: 'Guiana Francesa'},
  {alpha: 'GN', name: 'Guiné'},
  {alpha: 'GQ', name: 'Guiné Equatorial'},
  {alpha: 'GW', name: 'Guiné-Bissau'},
  {alpha: 'HT', name: 'Haiti'},
  {alpha: 'HN', name: 'Honduras'},
  {alpha: 'HK', name: 'Hong Kong'},
  {alpha: 'HU', name: 'Hungria'},
  {alpha: 'YE', name: 'Iêmen'},
  {alpha: 'BV', name: 'Ilha Bouvet'},
  {alpha: 'CX', name: 'Ilha Christmas'},
  {alpha: 'IM', name: 'Ilha de Man'},
  {alpha: 'HM', name: 'Ilha Heard e McDonald'},
  {alpha: 'NF', name: 'Ilha Norfolk'},
  {alpha: 'KY', name: 'Ilhas Cayman'},
  {alpha: 'CC', name: 'Ilhas Cocos (Keeling)'},
  {alpha: 'CK', name: 'Ilhas Cook'},
  {alpha: 'FK', name: 'Ilhas Falkland'},
  {alpha: 'FO', name: 'Ilhas Faroé'},
  {alpha: 'GS', name: 'Ilhas Geórgia do Sul e Sandwich do Sul'},
  {alpha: 'MP', name: 'Ilhas Marianas do Norte'},
  {alpha: 'MH', name: 'Ilhas Marshall'},
  {alpha: 'SB', name: 'Ilhas Salomão'},
  {alpha: 'SJ', name: 'Ilhas Svalbard e Jan Mayen'},
  {alpha: 'TC', name: 'Ilhas Turks e Caicos'},
  {alpha: 'VG', name: 'Ilhas Virgens Britânicas'},
  {alpha: 'VI', name: 'Ilhas Virgens dos Estados Unidos'},
  {alpha: 'WF', name: 'Ilhas Wallis e Futuna'},
  {alpha: 'IN', name: 'Índia'},
  {alpha: 'ID', name: 'Indonésia'},
  {alpha: 'IR', name: 'Irã'},
  {alpha: 'IQ', name: 'Iraque'},
  {alpha: 'IE', name: 'Irlanda'},
  {alpha: 'IS', name: 'Islândia'},
  {alpha: 'IL', name: 'Israel'},
  {alpha: 'IT', name: 'Itália'},
  {alpha: 'JM', name: 'Jamaica'},
  {alpha: 'JP', name: 'Japão'},
  {alpha: 'JE', name: 'Jersey'},
  {alpha: 'JO', name: 'Jordânia'},
  {alpha: 'KI', name: 'Kiribati'},
  {alpha: 'KW', name: 'Kuwait'},
  {alpha: 'LA', name: 'Laos'},
  {alpha: 'LS', name: 'Lesoto'},
  {alpha: 'LV', name: 'Letônia'},
  {alpha: 'LB', name: 'Líbano'},
  {alpha: 'LR', name: 'Libéria'},
  {alpha: 'LY', name: 'Líbia'},
  {alpha: 'LI', name: 'Liechtenstein'},
  {alpha: 'LT', name: 'Lituânia'},
  {alpha: 'LU', name: 'Luxemburgo'},
  {alpha: 'MO', name: 'Macau'},
  {alpha: 'MK', name: 'Macedônia'},
  {alpha: 'MG', name: 'Madagascar'},
  {alpha: 'YT', name: 'Maiote'},
  {alpha: 'MY', name: 'Malásia'},
  {alpha: 'MW', name: 'Malaui'},
  {alpha: 'MV', name: 'Maldivas'},
  {alpha: 'ML', name: 'Mali'},
  {alpha: 'MT', name: 'Malta'},
  {alpha: 'MA', name: 'Marrocos'},
  {alpha: 'MQ', name: 'Martinica'},
  {alpha: 'MU', name: 'Maurício'},
  {alpha: 'MR', name: 'Mauritânia'},
  {alpha: 'MX', name: 'México'},
  {alpha: 'FM', name: 'Micronésia'},
  {alpha: 'MZ', name: 'Moçambique'},
  {alpha: 'MD', name: 'Moldávia'},
  {alpha: 'MC', name: 'Mônaco'},
  {alpha: 'MN', name: 'Mongólia'},
  {alpha: 'ME', name: 'Montenegro'},
  {alpha: 'MS', name: 'Montserrat'},
  {alpha: 'MM', name: 'Myanmar'},
  {alpha: 'NA', name: 'Namíbia'},
  {alpha: 'NR', name: 'Nauru'},
  {alpha: 'NP', name: 'Nepal'},
  {alpha: 'NI', name: 'Nicarágua'},
  {alpha: 'NE', name: 'Níger'},
  {alpha: 'NG', name: 'Nigéria'},
  {alpha: 'NU', name: 'Niue'},
  {alpha: 'NO', name: 'Noruega'},
  {alpha: 'NC', name: 'Nova Caledônia'},
  {alpha: 'NZ', name: 'Nova Zelândia'},
  {alpha: 'OM', name: 'Omã'},
  {alpha: 'NL', name: 'Países Baixos'},
  {alpha: 'PW', name: 'Palau'},
  {alpha: 'PS', name: 'Palestina'},
  {alpha: 'PA', name: 'Panamá'},
  {alpha: 'PG', name: 'Papua-Nova Guiné'},
  {alpha: 'PK', name: 'Paquistão'},
  {alpha: 'PY', name: 'Paraguai'},
  {alpha: 'PE', name: 'Peru'},
  {alpha: 'PN', name: 'Pitcairn'},
  {alpha: 'PF', name: 'Polinésia Francesa'},
  {alpha: 'PL', name: 'Polônia'},
  {alpha: 'PR', name: 'Porto Rico'},
  {alpha: 'PT', name: 'Portugal'},
  {alpha: 'KE', name: 'Quênia'},
  {alpha: 'KG', name: 'Quirguistão'},
  {alpha: 'GB', name: 'Reino Unido'},
  {alpha: 'CF', name: 'República Centro-Africana'},
  {alpha: 'DO', name: 'República Dominicana'},
  {alpha: 'CZ', name: 'República Tcheca'},
  {alpha: 'RE', name: 'Reunião'},
  {alpha: 'RO', name: 'Romênia'},
  {alpha: 'RW', name: 'Ruanda'},
  {alpha: 'MF', name: 'Saint Martin (parte francesa)'},
  {alpha: 'WS', name: 'Samoa'},
  {alpha: 'AS', name: 'Samoa Americana'},
  {alpha: 'SH', name: 'Santa Helena'},
  {alpha: 'LC', name: 'Santa Lúcia'},
  {alpha: 'BL', name: 'São Bartolomeu'},
  {alpha: 'KN', name: 'São Cristóvão e Névis'},
  {alpha: 'SM', name: 'São Marinho'},
  {alpha: 'PM', name: 'São Pedro e Miquelon'},
  {alpha: 'ST', name: 'São Tomé e Príncipe'},
  {alpha: 'VC', name: 'São Vicente e Granadinas'},
  {alpha: 'SC', name: 'Seicheles'},
  {alpha: 'SN', name: 'Senegal'},
  {alpha: 'SL', name: 'Serra Leoa'},
  {alpha: 'RS', name: 'Sérvia'},
  {alpha: 'SG', name: 'Singapura'},
  {alpha: 'SX', name: 'Sint Maarten (parte holandesa)'},
  {alpha: 'SY', name: 'Síria'},
  {alpha: 'SO', name: 'Somália'},
  {alpha: 'LK', name: 'Sri Lanka'},
  {alpha: 'SD', name: 'Sudão'},
  {alpha: 'SS', name: 'Sudão do Sul'},
  {alpha: 'SE', name: 'Suécia'},
  {alpha: 'CH', name: 'Suíça'},
  {alpha: 'SR', name: 'Suriname'},
  {alpha: 'TJ', name: 'Tadjiquistão'},
  {alpha: 'TH', name: 'Tailândia'},
  {alpha: 'TW', name: 'Taiwan'},
  {alpha: 'TZ', name: 'Tanzânia'},
  {alpha: 'IO', name: 'Território Britânico do Oceano Índico'},
  {alpha: 'TF', name: 'Territórios Franceses do Sul'},
  {alpha: 'UM', name: 'Territórios Insulares dos Estados Unidos'},
  {alpha: 'TL', name: 'Timor-Leste'},
  {alpha: 'TG', name: 'Togo'},
  {alpha: 'TK', name: 'Tokelau'},
  {alpha: 'TO', name: 'Tonga'},
  {alpha: 'TT', name: 'Trinidad e Tobago'},
  {alpha: 'TN', name: 'Tunísia'},
  {alpha: 'TM', name: 'Turcomenistão'},
  {alpha: 'TR', name: 'Turquia'},
  {alpha: 'TV', name: 'Tuvalu'},
  {alpha: 'UA', name: 'Ucrânia'},
  {alpha: 'UG', name: 'Uganda'},
  {alpha: 'UY', name: 'Uruguai'},
  {alpha: 'UZ', name: 'Uzbequistão'},
  {alpha: 'VU', name: 'Vanuatu'},
  {alpha: 'VE', name: 'Venezuela'},
  {alpha: 'VN', name: 'Vietnã'},
  {alpha: 'ZM', name: 'Zâmbia'},
  {alpha: 'ZW', name: 'Zimbábue'},
]
